<div class="trip-detail-popup-right">
    <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()">
</div>
<form class="admin-forms" [formGroup]="addworkform">
    <div class="accordion-class">
        <h5>Notify Near by Drivers</h5>
        <mat-divider></mat-divider>
    </div>
    <div class="input-fileds-container">
        <div class="group driver-truck">
            <div class="row mtb align-items-center">
                <div class="col-md-2 ex7">
                    <label class="txt" for="html">Work Order No:</label>
                </div>
                <div class="col-md-3">
                    <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
                        <mat-select dropLocationSearchField formControlName="work_order" required>
                           
                        </mat-select>
                    </mat-form-field>
                </div>
              
                <div class="col-md-1 submit-link">
                    <a class="c1" href="">Submit</a>
                </div>

                <div class="col-md-2 ex5">
                    <label for="html">Actual Price Per Ton:</label>
                </div>
                <div class="col-md-3">
                    <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
                        <input matInput formControlName="actul_pricce">
                      
                    </mat-form-field>
                       
                </div>

            </div>
            <div class="row mtb align-items-center">
                <div class="col-md-2 ex7">
                    <label for="html">Work Order Date:</label>
                </div>
                <div class="col-md-3">
                    <mat-form-field class="flex-gt-sm example-full-width truck-type-input">

                        <input matInput formControlName="work_no" required>
                       
                    </mat-form-field>
                </div>
                <div class="col-md-2 ex0">
                    <label for="html">Work Order Quantity:</label>
                </div>
                <div class="col-md-3">
                    <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
                        <input matInput formControlName="work_qty" required>
                       
                    </mat-form-field>
                </div>
                <div class="col-md-2 ex11">
                    <p class="tons">Tons</p>
                </div>
            </div>
            <hr>
            <h5 class="c2"> Trip Details</h5>
            <br>
            <div class="row mtb align-items-center">
                <div class="col-md-2 ex7">
                    <label for="html"> Trip Booking Date:</label>
                </div>
                <div class="col-md-3">
                    <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
                        <input matInput formControlName="trip_book" required>
                        
                    </mat-form-field>
                </div>
                <div class="col-md-2 ex11">
                    <label for="html">Truck Type</label>
                </div>
                <div class="col-md-3">
                    <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
                        <mat-select dropLocationSearchField formControlName="truck_category" required>
                            
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row mtb align-items-center">
                <div class="col-md-2 ex11">
                    <label for="html">Price Per Ton:</label>
                </div>
                <div class="col-md-3">
                    <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
                        <input matInput formControlName="price_ton" required>
                        
                    </mat-form-field>
                </div>
            </div>
            <hr>
            <h5 class="c3"> Notification Settings (From Pickup)</h5>
            <br>
            <div class="row mtb align-items-center">
                <div class="col-md-2 ex7">
                    <label for="html"> Notification Radius:</label>
                </div>
                <div class="col-md-3">
                    <mat-form-field class="flex-gt-sm example-full-width truck-type-input">
                        <input matInput formControlName="" required>
                      
                    </mat-form-field>
                </div>
                <div class="col-md-2 ex11">
                    <label for="html">KMS</label>
                </div>
            </div>
        </div>
    </div>
            <div class="col-md-7">
                <div class="c6">
                    <button type="submit" class="button buttonBlue">Notify</button>
                </div>
            </div>
       
   
</form>